<template>
  <div class="clientContent">
    <div class="clientForm">
      <el-form label-width="100px" :rules="rules" ref="clientFormRules" :model="clientInfo">
        <div class="flexStyle mainContent">
          <div class="imgStyle">
            <upload-image
              :imageUrl.sync="clientInfo.companyLogo"
              :imageUrls.sync="clientInfo.companyLogoKey"
            />
            <el-button v-if="clientInfo.companyLogo" @click="deleteImg">删除图片</el-button>
          </div>
          <div style="margin-left: 20px">
            <div class="flexStyle">
              <div class="flexStyleCloum">
                <el-form-item label="职位名称：" prop="jobTitle">
                  <el-input v-model="clientInfo.jobTitle"></el-input>
                </el-form-item>
                <el-form-item label="公司名称：" prop="corporateName">
                  <el-autocomplete
                    class="inline-input"
                    v-model="clientInfo.corporateName"
                    :fetch-suggestions="enterpriseNameQuerySearch"
                    placeholder="请输入"
                    :trigger-on-focus="false"
                    @select="enterpriseNameSelect"
                    @input="inputChanged"
                  ></el-autocomplete>
                  <!-- <el-input v-model="clientInfo.corporateName"></el-input> -->
                </el-form-item>
                <el-form-item label="职位类型：">
                  <drop-down-box
                    :selectValue.sync="clientInfo.positionType"
                    typeCode="008"
                    class="dropDownBox"
                  />
                </el-form-item>
                <el-form-item label="学历要求：">
                  <drop-down-box
                    :selectValue.sync="clientInfo.educationalRequirements"
                    typeCode="007"
                  />
                </el-form-item>
                <el-form-item label="薪资范围：">
                  <div class="flexStyle">
                    <el-input v-model="salary[0]" style="width: 250px">
                      <el-select
                        v-model="clientInfo.isAnnual"
                        slot="prepend"
                        placeholder="请选择"
                        style="width: 100px"
                      >
                        <el-option label="年薪" :value="1"></el-option>
                        <el-option label="月薪" :value="0"></el-option>
                      </el-select>
                    </el-input>
                    <span class="spanStyle">~</span>
                    <el-input v-model="salary[1]" class="small_input"></el-input>
                  </div>
                </el-form-item>
              </div>
              <div class="flexStyleCloum" style="margin-left: 20px">
                <el-form-item label="工作地点：" prop="companyArea">
                  <!-- <CascaderArea
                    :country="clientInfo.companyCountry"
                    :province="clientInfo.companyProvince"
                    :city="clientInfo.companyCity"
                    @searchArae="searchArae"
                  /> -->
                  <div class="distpicker">
                    <v-distpicker
                      @selected="onSelected"
                      :province="clientInfo.companyProvince"
                      :city="clientInfo.companyCity"
                      :area="clientInfo.companyArea"
                    ></v-distpicker>
                  </div>
                  <div class="input">
                    <el-input
                      class="dutyStation"
                      v-model="clientInfo.dutyStation"
                      placeholder="请输入详细地址"
                    ></el-input>
                  </div>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <el-form-item label="职位描述" prop="jobDescription" class="formStyle">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              v-model="clientInfo.jobDescription"
            ></el-input>
          </el-form-item>
          <el-form-item label="所需技能" prop="requiredSkills" class="formStyle">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              v-model="clientInfo.requiredSkills"
            ></el-input>
          </el-form-item>
          <el-form-item label="福利待遇" class="formStyle">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              v-model="clientInfo.fringeBenefits"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="buttonStyle">
      <el-button class="saveButton" @click="save">保存</el-button>
      <el-button class="cancelButton" @click="cancel">取消</el-button>
    </div>
    <div class="bottom"></div>
  </div>
</template>

<script>
// import CascaderArea from '@/components/CascaderArea.vue'
import UploadImage from '@/components/UploadImage.vue'
import { save, update, getpositionListByid } from '@/api/position.js'
import DropDownBox from '../../../../components/DropDownBox.vue'
import { getCompanyNamesLogo } from '@/api/enterprise.js'

export default {
  // CascaderArea,
  components: {
    UploadImage,
    DropDownBox
  },
  data() {
    return {
      options: ['计算机', '自动化', '人工智能', '建筑', '房地产'],
      cilentNature: ['民企', '国企', '上市公司', '外企', '合资', '政府', '事业单位', '其他'],
      cilentScale: [
        '1-49人',
        '50-99人',
        '100-499人',
        '500-999人',
        '1000-2000人',
        '2000-5000人',
        '5000-10000人',
        '10000人以上'
      ],
      cilentState: ['未合作', '合作中', '待续约'],
      clientInfo: {
        companyName: '', // 企业简称
        companyArea: '', // 所在地区
        companyLogo: '', //公司logo
        companyLogoKey: '', //公司logo
        corporateName: '', //公司名称
        companyCountry: '', //所在国家
        companyCity: '', //所在城市
        companyProvince: '', //所在省份
        educationalRequirements: '', //学历要求
        fringeBenefits: '', //福利待遇
        jobDescription: '', //职位描述
        jobTitle: '', //职位名称
        positionType: '', //职位类型
        requiredSkills: '', //所需技能
        salaryRange: '' //薪资范围
      },
      salary: [],
      rules: {
        jobTitle: [{ required: true, message: '请填写职位名称', trigger: 'onChange' }],
        corporateName: [{ required: true, message: '请填写公司名称', trigger: 'onChange' }],
        jobDescription: [{ required: true, message: '请填写职位描述', trigger: 'onChange' }],
        companyArea: [{ required: true, message: '请选择工作地点', trigger: 'blur' }],
        requiredSkills: [{ required: true, message: '请填写所需技能', trigger: 'onChange' }]
      },
      enterpriseNameList: [] //查询到的企业名称
    }
  },
  computed: {
    Authorization() {
      return sessionStorage.getItem('token')
    },
    clientType() {
      return this.$route.query.clientType
    },
    clientId() {
      return this.$route.query.id
    },
    searchInfo() {
      if (this.$route.query.searchInfo) {
        return JSON.parse(this.$route.query.searchInfo)
      } else {
        return null
      }
    }
  },
  created() {
    this.$store.commit('changeQueryInfo', this.searchInfo)
    if (this.clientType) {
      this.getpositionListByid()
    }
  },
  methods: {
    //选择企业名称
    async enterpriseNameSelect(item) {
      const { data: res } = await getCompanyNamesLogo({ name: item.value })
      if (res.resultCode === 200) {
        const {
          companySimpleName,
          companyName,
          logo,
          logoList,
          companyProvince,
          companyCity,
          companyDistrict,
          companyAddress
        } = res.data[0]
        this.clientInfo.companyName = companySimpleName // 企业简称
        this.clientInfo.corporateName = companyName // 企业全称
        // 提交的图片地址
        this.clientInfo.companyLogo = logo
        // 回显的图片
        this.clientInfo.companyLogoKey = logoList
        this.clientInfo.companyProvince = companyProvince
        this.clientInfo.companyCity = companyCity
        this.clientInfo.companyArea = companyDistrict
        this.clientInfo.dutyStation = companyAddress
        this.enterpriseNameList = []
      }
    },
    //查询企业名称
    async enterpriseNameQuerySearch(str, cb) {
      if (str != '') {
        const { data: res } = await getCompanyNamesLogo({ name: str })
        if (res.resultCode === 200) {
          res.data.forEach((item) => {
            this.enterpriseNameList.push({
              value: item.companyName
            })
          })
          cb(this.enterpriseNameList)
        } else {
          this.$message.error('查询失败！')
        }
      }
    },
    //输入值变化时
    inputChanged() {
      this.enterpriseNameList = []
    },
    // 单个查询
    async getpositionListByid() {
      const res = await getpositionListByid({ id: this.clientId })
      if (res.data.resultCode == 200) {
        this.clientInfo = res.data.data
        if (this.clientInfo.salaryRange) {
          this.salary = this.clientInfo.salaryRange.split('~')
        }
      }
    },
    //   添加联系人
    addprojectLeaderListAdd() {
      this.clientInfo.projectLeaderListAdd.push({
        contactInformation: '', //微信号
        projectLeader: '', //联系人姓名
        targetEnterprise: ''
      })
    },
    // 国家地区
    // searchArae(val) {
    //   this.clientInfo.companyCountry = val.country

    //   this.clientInfo.companyProvince = val.province

    //   if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
    //     this.clientInfo.companyCity = val.city
    //   }
    // },
    //工作地址
    onSelected(data) {
      console.log('工作地点', data)
      this.clientInfo.companyProvince = data.province.value
      this.clientInfo.companyCity = data.city.value
      this.clientInfo.companyArea = data.area.value
    },
    //   删除联系人
    removeprojectLeaderListAdd(index) {
      this.clientInfo.projectLeaderListAdd.splice(index, 1)
    },
    // 保存
    save() {
      this.$refs.clientFormRules.validate(async (valid) => {
        if (valid) {
          if (this.salary.length > 0) {
            this.clientInfo.salaryRange = this.salary.join('~')
          }
          let res
          if (this.clientType) {
            res = await update(this.clientInfo)
          } else {
            res = await save(this.clientInfo)
          }
          if (res.data.resultCode === 200) {
            if (this.clientType) {
              this.$message.success('修改成功')
            } else {
              this.$message.success('新增成功')
            }
            this.$router.go(-1)
          }
        }
      })
    },
    // 返回
    cancel() {
      this.$router.go(-1)
    },
    // 删除图片
    deleteImg() {
      ;(this.clientInfo.companyLogo = ''), (this.clientInfo.companyLogoKey = '')
    }
  }
}
</script>

<style scoped lang="less">
.clientContent {
  position: relative;
}
.clientForm {
  height: calc(100vh - 188px);
  overflow: auto;
  // padding-bottom: 72px;
}
.mainContent {
  background-color: #fff;
  padding: 20px;
}
.flexStyle {
  display: flex;
}
.flexStyleCloum {
  display: flex;
  flex-direction: column;
}
.inputStyle {
  /deep/ .el-input {
    margin: 0 5px 5px 0;
  }
  .iconStyle {
    display: inline-block;
    height: 100%;
    font-size: 28px;
    vertical-align: middle;
    cursor: pointer;
    color: #17757a;
  }
}
.buttonStyle {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // // width: 100%;
  // background-color: #fff;
  // padding: 0 10px 20px 10px;
  display: flex;
  margin-top: 50px;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 72px;
  left: 0;
  bottom: -10px;
  background: #fff;
  width: 100%;
  box-shadow: 0px 0px 4px 0px #00000040;
}
/deep/ .saveButton {
  background-color: #17757a !important;
  color: #fff;
  padding: 10px 30px;
}
/deep/ .cancelButton {
  border-color: #17757a !important;
  color: #17757a;
  padding: 10px 30px;
}
/deep/ .el-button:focus,
.el-button:hover {
  background-color: #fff;
}
.bottom {
  height: 20px;
}
.spanStyle {
  display: inline-block;
  padding: 0 10px;
  color: #17757a;
}
.dropDownBox {
  /deep/ .el-input__inner {
    width: 100%;
  }
  /deep/ .el-select {
    width: 100%;
  }
}
.formStyle {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
  /deep/ .el-form-item__label {
    display: block;
    width: 100% !important;
    text-align: left;
    color: #17757a;
    font-size: 15px;
    font-weight: 600;
  }
}
.imgStyle {
  text-align: center;
  /deep/ .el-button {
    padding: 5px 10px;
    border-color: #17757a;
    color: #17757a;
  }
}
.el-autocomplete {
  width: 100%;
}
.distpicker {
  margin-right: 10px;
  margin-bottom: 10px;
  ::v-deep .distpicker-address-wrapper select {
    min-width: 100px;
    height: 40px;
    font-size: 14px;
    padding: 0 5px;
  }
  ::v-deep .el-input__inner {
    width: 300px;
    height: 32px;
    box-sizing: border-box;
  }
}
// ::v-deep .el-form-item .el-form-item__content {
//   display: flex;
//   flex-flow: row nowrap;
// }
// /deep/ .el-textarea__inner {
//   text-indent: 2em;
// }

/* 媒体查询：自适应 */
// 1680x1050 (1680x889)
@media (max-width: 1682px) and (max-height: 890px) {
  .clientForm {
    height: calc(100vh - 128px - 57px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .buttonStyle {
    bottom: 14px !important;
  }
}

// 1600x900 (1600x739)
@media (max-width: 1602px) and (max-height: 740px) {
  .clientForm {
    height: calc(100vh - 128px - 57px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .buttonStyle {
    bottom: 164px !important;
  }
}

// 1366x768 (1366x607)
@media (max-width: 1368px) and (max-height: 608px) {
  .clientForm {
    height: calc(100vh - 128px - 57px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .buttonStyle {
    bottom: 296px !important;
  }
}

// 1280x1024 (1280x863)
@media (max-width: 1282px) and (max-height: 864px) {
  .clientForm {
    height: calc(100vh - 128px - 57px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .buttonStyle {
    bottom: 40px !important;
  }
}

// 1280x960 (1280x799)
@media (max-width: 1282px) and (max-height: 800px) {
  .clientForm {
    height: calc(100vh - 128px - 57px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .buttonStyle {
    bottom: 106px !important;
  }
}

// 1280x800 (1280x639)
@media (max-width: 1282px) and (max-height: 640px) {
  .clientForm {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .buttonStyle {
    bottom: 262px !important;
  }
}

// 1280x768 (1280x607)
@media (max-width: 1282px) and (max-height: 608px) {
  .clientForm {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .buttonStyle {
    bottom: 296px !important;
  }
}

// 1280x720 (1280x599)
@media (max-width: 1282px) and (max-height: 600px) {
  .clientForm {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .buttonStyle {
    bottom: 342px !important;
  }
}

// 1280x600 (1280x439)
@media (max-width: 1282px) and (max-height: 440px) {
  .clientForm {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .buttonStyle {
    bottom: 464px !important;
  }
}

// 1152x864 (1152x703)
@media (max-width: 1153px) and (max-height: 704px) {
  .clientForm {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .buttonStyle {
    bottom: 198px !important;
  }
}

// 1024x768 (1024x607)
@media (max-width: 1025px) and (max-height: 608px) {
  .clientForm {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .buttonStyle {
    bottom: 294px !important;
  }
}

// 800x600 (800x439)
@media (max-width: 801px) and (max-height: 440px) {
  .clientForm {
    height: calc(100vh - 128px - 54px) !important;
    padding-bottom: 57px !important;
    overflow: auto;
  }
  .buttonStyle {
    bottom: 462px !important;
  }
}
</style>
